export function CompassIcon({
  width,
  height,
  draggable = false,
}: {
  width: number;
  height: number;
  draggable?: boolean;
}) {
  return (
    <div draggable={draggable}>
      <svg
        width={`${width}`}
        height={`${height}`}
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M55.9508 35.1473C55.9508 25.0897 47.7976 16.9365 37.74 16.9365C27.6825 16.9365 19.5293 25.0897 19.5293 35.1473C19.5293 45.2048 27.6825 53.358 37.74 53.358V54.3424C27.1389 54.3424 18.5449 45.7484 18.5449 35.1473C18.5449 24.5461 27.1389 15.9521 37.74 15.9521C48.3412 15.9521 56.9351 24.5461 56.9351 35.1473C56.9351 45.7484 48.3412 54.3424 37.74 54.3424V53.358C47.7976 53.358 55.9508 45.2048 55.9508 35.1473Z"
          fill="#000000"
        />
        <path
          d="M40.5902 30.4753L48.6554 24.2317L42.4118 32.295L64.81 35.1472L42.4109 37.9974L48.6554 46.0627L40.5902 39.8181L37.74 62.2172L34.8878 39.8191L26.8245 46.0627L33.0681 37.9974L10.6699 35.1472L33.0671 32.295L26.8245 24.2317L34.8878 30.4743L37.74 8.07715L40.5902 30.4753ZM37.74 32.3911C36.2177 32.3911 34.9839 33.625 34.9839 35.1472C34.9839 36.6694 36.2177 37.9032 37.74 37.9032C39.2622 37.9032 40.496 36.6694 40.496 35.1472C40.496 33.625 39.2622 32.3911 37.74 32.3911Z"
          fill="#000000"
        />
        <path
          d="M37.7403 8.19043L36.0176 21.7252L37.7403 21.7252L39.4629 21.7252L37.7403 8.19043Z"
          fill="#D32F2F"
        />
        <path
          d="M40.2655 2V8.26379H39.3916L36.2165 3.68707H36.1646V8.26379H35.2129V2H36.0954L39.2705 6.58537H39.3311V2H40.2655Z"
          fill="#D32F2F"
        />
        <path
          d="M39.0678 65.2849C39.0073 64.7052 38.4968 64.3678 37.7788 64.3678C37.0088 64.3678 36.5243 64.7571 36.5243 65.2935C36.5243 65.8905 37.1731 66.1154 37.6663 66.2366L38.2719 66.4009C39.0765 66.5913 40.0714 67.0325 40.0801 68.1659C40.0714 69.2214 39.2322 70 37.7528 70C36.3512 70 35.4688 69.2992 35.4082 68.1572H36.3599C36.4204 68.8407 37.0174 69.1695 37.7528 69.1695C38.5487 69.1695 39.1284 68.7628 39.1371 68.1486C39.1284 67.6035 38.618 67.3786 37.9518 67.2055L37.2077 67.0066C36.2042 66.7297 35.5726 66.2193 35.5726 65.3454C35.5726 64.264 36.5416 63.5459 37.8047 63.5459C39.0765 63.5459 39.9676 64.2726 39.9936 65.2849H39.0678Z"
          fill="#000000"
        />
        <path
          d="M3.73898 38.5909L2 32.3271H3.00359L4.22347 37.1721H4.27538L5.54717 32.3271H6.53346L7.80525 37.1721H7.85716L9.07704 32.3271H10.0806L8.34165 38.5909H7.38132L6.06627 33.9104H6.01436L4.69931 38.5909H3.73898Z"
          fill="#000000"
        />
        <path
          d="M66.0352 38.5909V32.3271H69.963V33.1491H66.9868V35.0438H69.7554V35.857H66.9868V37.769H69.9976V38.5909H66.0352Z"
          fill="#000000"
        />
      </svg>
    </div>
  );
}
